export default "__VITE_ASSET__aad60582__"